import {convertFromKm, getUnitLabel} from "../distanceConverter/distanceConverter";
import {DistanceUnit, DEFAULT_DISTANCE_UNIT} from "../../constans/statuses/distanceUnits";

export const DisplayFlyDistance = (distanceInKm: number, userDistanceUnit: DistanceUnit = DEFAULT_DISTANCE_UNIT): string => {
  const convertedDistance = convertFromKm(distanceInKm, userDistanceUnit);
  const unitLabel = getUnitLabel(userDistanceUnit);
  
  return `${convertedDistance.toFixed(1)} ${unitLabel}`;
}